{
  "AI-Requested via phone call": "AI-Requested via phone call",
  "AI-Requested via text message": "AI-Requested via text message",
  "Appointment request completed successfully": "Appointment request completed successfully",
  "Appointment request deleted successfully": "Appointment request deleted successfully",
  "Appointment request dismissed successfully": "Appointment request dismissed successfully",
  "Appointment request rejected successfully": "Appointment request rejected successfully",
  "Are you sure you want to delete this request?": "Are you sure you want to delete this request?",
  "Are you sure you want to dismiss this request?": "Are you sure you want to dismiss this request?",
  "Are you sure you want to reject this request?": "Are you sure you want to reject this request?",
  "Availability Preferences": "Availability Preferences",
  "Call": "Call",
  "Confirm": "Confirm",
  "Contact information": "Contact information",
  "Contacted on {{lastContactedOn}}": "Contacted on {{lastContactedOn}}",
  "Date of Birth": "Date of Birth",
  "Delete": "Delete",
  "Dismiss": "Dismiss",
  "Done": "Done",
  "Failed to complete appointment request": "Failed to complete appointment request",
  "Failed to delete appointment request": "Failed to delete appointment request",
  "Failed to dismiss appointment request": "Failed to dismiss appointment request",
  "Failed to make phone call to patient": "Failed to make phone call to patient",
  "Failed to reject appointment request": "Failed to reject appointment request",
  "Failed to send message to patient": "Failed to send message to patient",
  "Last Contacted on {{datetime}}": "Last Contacted on {{datetime}}",
  "Message": "Message",
  "Reason for Visit": "Reason for Visit",
  "Reject Request": "Reject Request",
  "Request": "Request",
  "Requested on {{requestTime}}": "Requested on {{requestTime}}",
  "Review Request": "Review Request",
  "View Call Insights": "View Call Insights",
  "View Conversation": "View Conversation",
  "View Request": "View Request",
  "You do not have permission to send text messages": "You do not have permission to send text messages"
}
